import React, { useState, useRef, useEffect } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Joyn2Button from './Joyn2Button';
import './DateRange.css';
import { closeIconSvg } from '../../HelperMethods/constants';

const DateRangeComponent = ({ callback, range = {}, handleShowCalendar, validation, ...props }) => {
  const initialState = [
    {
      startDate: range.startDate || new Date(),
      endDate: range.endDate || new Date(),
      key: 'selection',
    },
  ];
  const [dateRange, setDateRange] = useState(initialState);
  const [error, handleValidation] = useState('');

  const handleOnChange = (item) => {
    if (validation) {
      const { isValid, message } = validation([item.selection]);
      if (isValid) {
        handleValidation('');
        setDateRange([item.selection]);
      } else {
        handleValidation(message);
      }
    } else {
      setDateRange([item.selection]);
    }
  };
  const handleReset = () => {
    setDateRange(initialState);
  };
  const handleClose = () => {
    handleShowCalendar();
  };
  const handleSelectToday = () => {
    callback([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
  };

  const dateRangeRef = useRef();

  const handleClickOutside = (event) => {
    // IF exists the Ref of the wrapped component AND his dom children doesnt have the clicked component
    if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
      // A props callback for the ClikedClickedOutside
      handleShowCalendar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dateRangeRef}>
      <div className="dateRangeHeader">
        <div style={{ magrin: '2% 0 0 90%' }}>
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
            onClick={handleClose}
            style={{ cursor: 'pointer', float: 'right', margin: '5px' }}
            alt="Close Icon"
          />
        </div>
      </div>
      <div style={{ background: 'white' }}>
        <DateRange
          editableDateInputs
          onChange={(item) => handleOnChange(item)}
          ranges={dateRange}
          rangeColors={['rgba(227, 249, 247, 0.6)']}
          {...props}
        />
        <div className="errorText">* {error}</div>
        <div style={{ padding: '2% 0 2% 44%', display: 'flex' }}>
          <Joyn2Button size="medium" type="button" label="Reset" btnType="secondary" onClick={handleReset} />
          <Joyn2Button
            size="medium"
            type="button"
            label="Today"
            btnType="secondary"
            onClick={handleSelectToday}
            margin="0 12px 0 12px"
          />
          <Joyn2Button size="medium" label="Done" type="submit" onClick={error ? null : () => callback(dateRange)} />
        </div>
      </div>
    </div>
  );
};

export default DateRangeComponent;
